import { ProjectMember } from "domain/entities/project-member";
import { create } from "zustand";
import { devtools } from "zustand/middleware";


interface ProjectMemberDeleteState {
  projectMembersDelete: ProjectMember[];
  setProjectMembersDelete: (newProjectMembers: ProjectMember[] | undefined) => void;
}

export const useProjectMemberDeleteStore = create<ProjectMemberDeleteState>()(
  devtools(
    (set) => ({
      projectMembersDelete: [],
      setProjectMembersDelete: (newProjectMembers) =>
        set(() => ({
          projectMembersDelete: newProjectMembers ? [...newProjectMembers] : [],
        })),
    }),
    { name: "projectMembersDeleteedStore" }
  )
);
